import React, { useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import SpotifyListItem from "./spotify-list-item";
import YoutubeListItem from "./youtube-list-item";
import { Box } from "../../comps";

const ListWrapper = styled(Box)`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export default ({ modalData, items, actions, time }) => {
  useEffect(() => {
    console.log("refreshing queue");
    const resultGrid = new MuuriGrid(".importcdccModalgrid", {
      dragEnabled: false,
      layout: { fillGaps: true, alignLeft: true, alignTop: true },
    });
  }, [time]);
  return (
    <ListWrapper>
      <div class="grid importcdccModalgrid">
        {items.map((item, idx) => {
          return item.isSpotifyTrack ? (
            <SpotifyListItem
              item={item}
              convert={() => {
                actions.convert(idx);
              }}
            />
          ) : (
            <YoutubeListItem
              item={item}
              isModalView={modalData && true}
              handleAddSongs={modalData && modalData.handleAddSongs}
              play={() => {
                actions.play(idx);
              }}
              addToPlaylist={() => {
                actions.addToPlaylist(idx);
              }}
              addToQueue={() => {
                actions.queue(idx);
              }}
            />
          );
        })}
      </div>
    </ListWrapper>
  );
};
